<template>
  <div class="headerfigma">
    <div class="pc"><HeaderBreadcrumbsDesktop :player="player" v-model="value" @input="input" /></div>
    <div class="tablet"><HeaderBreadcrumbsTablet :player="player" v-model="value" @input="input" /></div>
    <div class="m320"><HeaderBreadcrumbsMobile320 :player="player" v-model="value" @input="input" /></div>
  </div>
</template>

<script>
import HeaderBreadcrumbsDesktop from '@/components/Sections/HeaderFigma/HeaderBreadcrumbsDesktop';
import HeaderBreadcrumbsTablet from '@/components/Sections/HeaderFigma/HeaderBreadcrumbsTablet';
import HeaderBreadcrumbsMobile320 from '@/components/Sections/HeaderFigma/HeaderBreadcrumbsMobile320';
export default {
  name: 'HeaderFigma',
  props: {
    player: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      default: -1,
    },
  },
  methods: {
    input(id) {
      this.$emit('input', id);
    },
  },
  components: {
    HeaderBreadcrumbsDesktop,
    HeaderBreadcrumbsTablet,
    HeaderBreadcrumbsMobile320,
  },
};
</script>
<style>
:root {
  --big-stone: #132739;
  --black: #000000;
  --dodger-blue: #23b0ff;
  --white: #ffffff;

  --font-size-l: 11.6px;
  --font-size-m: 10px;
  --font-size-s: 6px;
  --font-size-xl: 16px;
  --font-size-xxl: 18px;
  --font-size-xxxl: 19.4px;
  --font-size-xxxxl: 24px;

  --font-family-avenir_next_lt_pro-bold: 'Avenir-Bold';
  --font-family-avenir_next_lt_pro-demi: 'Avenir-Demi';
  --font-family-avenir_next_lt_pro-light: 'Avenir-Regular';
  --font-family-avenir_next_lt_pro-medium: 'Avenir-Demi-Medium';
}
.headerfigma .avenirnextltpro-demi-normal-white-6px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-s);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .avenirnextltpro-demi-normal-white-10px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .avenirnextltpro-light-white-10px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-light);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 300;
}

.headerfigma .avenirnextltpro-medium-big-stone-10px {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-medium);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 500;
}

.headerfigma .avenirnextltpro-demi-normal-big-stone-10px {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .avenirnextltpro-bold-big-stone-10px {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-bold);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 700;
}

.headerfigma .avenirnextltpro-demi-normal-white-18px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-xxl);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .avenirnextltpro-demi-normal-white-11-6px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-l);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .avenirnextltpro-bold-white-16px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-bold);
  font-size: var(--font-size-xl);
  font-style: normal;
  font-weight: 700;
}

.headerfigma .avenirnextltpro-light-white-18px {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-light);
  font-size: var(--font-size-xxl);
  font-style: normal;
  font-weight: 300;
}

.headerfigma .avenirnextltpro-medium-big-stone-19-4px {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-medium);
  font-size: var(--font-size-xxxl);
  font-style: normal;
  font-weight: 500;
}

.headerfigma .avenirnextltpro-demi-normal-big-stone-19-4px {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-xxxl);
  font-style: normal;
  font-weight: 400;
}

.headerfigma .screen a {
  display: contents;
  text-decoration: none;
}

.headerfigma .valign-text-middle {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  white-space: pre-line;
  text-align: left;
}
</style>
<style scoped lang="css">
.headerfigma * {
  box-sizing: border-box;
}

.headerfigma {
  color: white;
}
.pc {
  display: block;
  width: 100%;
}
.tablet {
  display: none;
}
@media (max-width: 1300px) {
  .tablet {
    display: block;
  }
  .pc {
    display: none;
  }
}
.m320 {
  display: none;
  width: 100%;
}
@media (max-width: 710px) {
  .tablet {
    display: none;
  }
  .m320 {
    display: block;
  }
}
</style>
